module.exports = __webpack_public_path__ + "static/0048-d9d688069473df193f81bf356c2cf5f1.png";